module.exports = "data:image/webp;base64,UklGRpQAAABXRUJQVlA4IIgAAACQBACdASoZABkAPpE6mUiloyIhMBgIALASCUATpygADFrN6IA8dIOZRx5xuAAA/nM0OKrdr2xIQMZGnlhUsksLA3y3fsHf/+pZ//2ln+Oh8luStfwAJw/82s0kKmjYeaIsEmwZw8062YoYgo/wK4gTLqtvMUQNfxllX0vEbWn0sSOoyLPHAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/islabloom.webp
// module id = qG8o
// module chunks = 14